import { render, staticRenderFns } from "./ColourSelectDialog.vue?vue&type=template&id=17eb0c9e&scoped=true"
import script from "./ColourSelectDialog.vue?vue&type=script&lang=js"
export * from "./ColourSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb0c9e",
  null
  
)

export default component.exports